import { render, staticRenderFns } from "./PedidosList.vue?vue&type=template&id=cea21ef2&scoped=true&"
import script from "./PedidosList.vue?vue&type=script&lang=js&"
export * from "./PedidosList.vue?vue&type=script&lang=js&"
import style0 from "./PedidosList.vue?vue&type=style&index=0&id=cea21ef2&lang=scss&scoped=true&"
import style1 from "./PedidosList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cea21ef2",
  null
  
)

export default component.exports